import { isMobile } from 'react-device-detect';
import { Trans } from 'react-i18next';

import useTranslate from '@/hooks/useTranslate';
import Card from '@/ui/members/components/Card';
import Heading from '@/ui/members/components/typography/Heading/Heading';
import UL from '@/ui/members/components/typography/UL';

import { GetAccessToV2Props } from './types';

const GetAccessToV2 = ({
  headingKey = 'featuresAvailableForFree',
  imageAltKey = 'screenOfInAppChallenges',
  imageSrc = '/images/onboarding/Challenges-and-Trends-2up.png',
  listItemKeys
}: GetAccessToV2Props) => {
  const translateKeyPath = 'pages.members.pages.Onboarding.components.shared.GetAccessTo';
  const { t } = useTranslate(translateKeyPath);

  return (
    <>
      <p className={`relative italic text-sm text-center ${isMobile ? 'mb-2' : 'mb-4'}`}>
        {t('thisShouldTakeAboutTwoMinutes')}
      </p>

      <div className="mb-6 text-center">
        <Card gradientBottom>
          <Heading className="font-medium mt-4" value={3} text={t(headingKey)} />

          <UL
            className={
              listItemKeys
                ? // Checkmarks hang in one column and wrapped lines start under the text
                  'flex flex-col items-start w-fit mx-auto text-left mb-4 [&_svg]:shrink-0'
                : 'flex flex-col items-center mb-4'
            }
            listStyle="greenCheckmarks"
            listItems={
              listItemKeys
                ? listItemKeys.map((key) => t(key))
                : [
                    t('inAppChallenges'),
                    t('motivatingMissions'),
                    <Trans
                      key="trans1"
                      i18nKey={`${translateKeyPath}.dailyInsights`}
                      components={[<br key="br1" />]}
                    />
                  ]
            }
          />

          <img className="mb-4" src={imageSrc} alt={t(imageAltKey)} />
        </Card>
      </div>
    </>
  );
};

export default GetAccessToV2;
